import {
  InputFieldConfig,
  SimpleEventLegacy,
  DerivedEventLegacy,
  ActiveCohortBuilderItemLegacy,
} from '@verantos-dev/types-cohorts';

import { addOrMutateIndexDateEvent, reduceIndexDateConfigMap } from '../utils/indexDateUtils';

export const addIndexDate = (
  indexDate: ActiveCohortBuilderItemLegacy,
  simpleEvents: SimpleEventLegacy[],
  derivedEvents: DerivedEventLegacy[]
): ActiveCohortBuilderItemLegacy => {
  const updatedIndexDate = addOrMutateIndexDateEvent(indexDate, derivedEvents);
  const configMap = reduceIndexDateConfigMap({} as Record<string, InputFieldConfig>, {
    indexDate: updatedIndexDate,
    simpleEvents,
    derivedEvents,
  });

  return {
    ...updatedIndexDate,
    inputFieldConfigMap: {
      ...updatedIndexDate.inputFieldConfigMap,
      ...configMap,
    },
  };
};
